import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_PROJECT_LONG_FORM_SECTION } from './schema';

const MUTATION = gql`
  mutation CreateLongFormBuilderOutlineSection(
    $projectId: ID!
    $draftId: ID!
    $headline: String!
    $order: Int!
    $afterSectionId: ID
    $instructions: String
    $assetType: String!
    $name: String
  ) {
    createLongFormBuilderOutlineSection(
      projectId: $projectId
      draftId: $draftId
      headline: $headline
      order: $order
      afterSectionId: $afterSectionId
      instructions: $instructions
      assetType: $assetType
      name: $name
    ) {
      ...LongFormSection
    }
  }
  ${FRAGMENT_PROJECT_LONG_FORM_SECTION}
`;

export const createLongFormBuilderOutlineSection = ({
  projectId,
  draftId,
  afterSectionId,
  instructions,
  assetType,
  name,
}) => {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: {
      projectId,
      draftId,
      headline: '', // for backward compatibility, "headline" is not used in "long form" sections anymore,
      order: -1, // for backward compatibility, FE now uses BE list order
      afterSectionId,
      instructions,
      assetType,
      name,
    },
  }).then(({ data }) => getSingleProp(data));
};
